import React, { useState, useEffect } from 'react';
import api from '../services/api';

function ServerSettings() {
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState(null);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const data = await api.get('/config/settings');
        setSettings(data);
      } catch (err) {
        console.error('Failed to fetch settings:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchSettings();
  }, []);

  const handleSectionChange = (section, key, value) => {
    setSettings(prev => ({
      ...prev,
      [section]: { ...prev[section], [key]: value },
    }));
  };

  const handleSave = async () => {
    setSaving(true);
    setMessage(null);
    try {
      await api.put('/config/settings', settings);
      setMessage({ type: 'success', text: 'Server settings saved successfully!' });
    } catch (err) {
      setMessage({ type: 'error', text: 'Failed to save settings.' });
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="card">Loading...</div>;

  const def = settings.DEFAULT || {};
  const georgia = settings.Georgia || {};
  const wss = settings.WSS || {};

  return (
    <div>
      <div className="page-header">
        <h2>Server Settings</h2>
        <p>Configure login server, proxy, and connection settings</p>
      </div>

      {message && (
        <div className={`alert alert-${message.type}`}>{message.text}</div>
      )}

      <div className="card">
        <div className="card-title">Default Profile</div>
        <div className="form-group">
          <label>Country List</label>
          <input
            type="text"
            value={def.CountryList || ''}
            onChange={e => handleSectionChange('DEFAULT', 'CountryList', e.target.value)}
          />
        </div>
        <div className="form-group">
          <label>Default Country</label>
          <input
            type="text"
            value={def.DefaultCountry || ''}
            onChange={e => handleSectionChange('DEFAULT', 'DefaultCountry', e.target.value)}
          />
        </div>
        <div className="form-group">
          <label>Default Server</label>
          <input
            type="text"
            value={def.DefaultServer || ''}
            onChange={e => handleSectionChange('DEFAULT', 'DefaultServer', e.target.value)}
          />
        </div>
        <div className="form-group">
          <label>Default Character</label>
          <input
            type="text"
            value={def.DefaultCharacter || ''}
            onChange={e => handleSectionChange('DEFAULT', 'DefaultCharacter', e.target.value)}
          />
        </div>
        <div className="form-group">
          <label>Default Account</label>
          <input
            type="text"
            value={def.DefaultAccount || ''}
            onChange={e => handleSectionChange('DEFAULT', 'DefaultAccount', e.target.value)}
          />
        </div>
      </div>

      <div className="card">
        <div className="card-title">Georgia Server</div>
        <div className="form-group">
          <label>Login Server IP</label>
          <input
            type="text"
            value={georgia.LoginServerIP || ''}
            onChange={e => handleSectionChange('Georgia', 'LoginServerIP', e.target.value)}
          />
        </div>
        <div className="form-group">
          <label>Login Server Port</label>
          <input
            type="text"
            value={georgia.LoginServerPort || ''}
            onChange={e => handleSectionChange('Georgia', 'LoginServerPort', e.target.value)}
          />
        </div>
        <div className="form-group">
          <label>Protocol Version</label>
          <input
            type="text"
            value={georgia.ProtocolVersion || ''}
            onChange={e => handleSectionChange('Georgia', 'ProtocolVersion', e.target.value)}
          />
        </div>
        <div className="form-group">
          <label>Server List</label>
          <input
            type="text"
            value={georgia.ServerList || ''}
            onChange={e => handleSectionChange('Georgia', 'ServerList', e.target.value)}
          />
        </div>
        <div className="form-group">
          <label>Proxy Server IP</label>
          <input
            type="text"
            value={georgia.ProxyServerIP || ''}
            onChange={e => handleSectionChange('Georgia', 'ProxyServerIP', e.target.value)}
          />
        </div>
        <div className="form-group">
          <label>Proxy Server Port</label>
          <input
            type="text"
            value={georgia.ProxyServerPort || ''}
            onChange={e => handleSectionChange('Georgia', 'ProxyServerPort', e.target.value)}
          />
        </div>
        <div className="form-group">
          <label>Use Proxy</label>
          <select
            value={georgia.UseProxy || '0'}
            onChange={e => handleSectionChange('Georgia', 'UseProxy', e.target.value)}
          >
            <option value="1">Enabled</option>
            <option value="0">Disabled</option>
          </select>
        </div>
        <div className="form-group">
          <label>is C4</label>
          <select
            value={georgia.isC4 || '0'}
            onChange={e => handleSectionChange('Georgia', 'isC4', e.target.value)}
          >
            <option value="1">Yes</option>
            <option value="0">No</option>
          </select>
        </div>
        <div className="form-group">
          <label>Do Encode/Decode</label>
          <select
            value={georgia.doEncDec || '0'}
            onChange={e => handleSectionChange('Georgia', 'doEncDec', e.target.value)}
          >
            <option value="1">Enabled</option>
            <option value="0">Disabled</option>
          </select>
        </div>
        <div className="form-group">
          <label>Do Outgoing Encode</label>
          <select
            value={georgia.doOutEnc || '0'}
            onChange={e => handleSectionChange('Georgia', 'doOutEnc', e.target.value)}
          >
            <option value="1">Enabled</option>
            <option value="0">Disabled</option>
          </select>
        </div>
        <div className="form-group">
          <label>Do RSA Encode</label>
          <select
            value={georgia.doRSAEnc || '0'}
            onChange={e => handleSectionChange('Georgia', 'doRSAEnc', e.target.value)}
          >
            <option value="1">Enabled</option>
            <option value="0">Disabled</option>
          </select>
        </div>
      </div>

      <div className="card">
        <div className="card-title">WSS Settings</div>
        <div className="form-group">
          <label>Port</label>
          <input
            type="text"
            value={wss.Port || ''}
            onChange={e => handleSectionChange('WSS', 'Port', e.target.value)}
          />
        </div>
      </div>

      <div className="btn-group">
        <button className="btn btn-primary" onClick={handleSave} disabled={saving}>
          {saving ? 'Saving...' : 'Save Server Settings'}
        </button>
      </div>
    </div>
  );
}

export default ServerSettings;
